<template>
  <div class="modal" id="modal-error">
    <div class="modal-container">
      <div class="modal-body">
        <!-- <div class="img-wrapper h-[53vw]">
          <img src="@/assets/img/error/gangguan.png" alt="Tap Sack" :class="errorType == 1 ? 'z-10' : '-z-10'">
          Offline:
          <img src="@/assets/img/error/koneksi.png" alt="Tap Sack" :class="errorType == 1 ? '-z-10' : 'z-10'">
        </div> -->
        <div class="text-wrapper text-center">
          <h2 class="text-black text-large font-semibold text-center mb-5 mt-7">{{ title }}</h2>
          <p class="px-5 text-black text-center mb-5 text-small">{{ bodyText }} </p>
        </div>
        <div class="footer w-full bg-pale-yellow pt-3 px-7">
          <div class="flex flex-row justify-center items-center">
            <!-- <div class="bg-[#ACADAD] text-white rounded-[1.5vw] py-3 w-[37vw] text-small text-center" id="btnOK" @click="backClicked" v-if="errorType !== 0">Kembali</div>
            <div class="bg-[#ACADAD] text-white rounded-[1.5vw] py-3 w-[37vw] text-small text-center" id="btnOK" @click="$emit('closeError')" v-else>Tutup</div>
            <div class="bg-primary-gold text-white rounded-[1.5vw] py-3 w-[37vw] text-small text-center"
              @click="$emit('closeError')"
              >
              Ok
            </div> -->
            <BaseButton @onClick="$emit('closeError')">
              <template #text>
                OK
              </template>
            </BaseButton>
            <!-- <router-link class="bg-primary-gold text-white rounded-[1.5vw] py-3 w-[37vw] text-small text-center" :class="!connection ? 'disabled' : ''" v-else :to="`/home/${auth}`">
              <button
                @click="$emit('closeError')"
                :disabled="connection == false"
                >
                Coba Lagi
              </button>
            </router-link> -->
          </div>
          <div class="disclaimer text-xs text-red-800 text-center font-bold py-1" :class="errorType!==1 && !connection ? 'visible' : 'invisible' ">
            Pastikan kamu terhubung ke Internet
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import BaseButton from '@/components/buttons/BaseButton.vue';
</script>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ModalError',
  props: {
    errorType: Number,
    resetError: Function,
    connection: Boolean,
    onBack: Function,
  },
  data() {
    return {
      // token: this.auth.split(' ')[1]
    };
  },
  computed: {
    ...mapState('global', ['errorMessage']),
    title() {
      if (this.errorType === 1) {
        // return 'Maaf'
        return 'Terjadi Kesalahan!';
      }
      return 'Tidak Ada Jaringan';
    },
    bodyText() {
      if (this.errorType === 1) {
        return this.errorMessage || 'Maaf terjadi gangguan pada jaringan silahkan coba beberapa saat lagi.';
      }
      return 'Maaf koneksi kamu terputus silahkan cek koneksi kamu dan coba beberapa saat lagi';
    },
    // image () {
    //   if (this.errorType === 1) {
    //     return require('@/assets/img/error/gangguan.png')
    //   }
    //   return require('@/assets/img/error/koneksi.png')
    // }
  },
  methods: {
    ...mapActions('global', ['setError']),
    backClicked() {
      if (this.$route.path === '/') {
        this.$emit('onBack');
      } else {
        this.$router.go(-1);
        this.setError({ status: false });
      }
    },
  },
  // mounted () {
  //   console.log(this.errorType)
  // }
};
</script>

<style scoped lang="scss">
img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.btn-cancel.disabled {
  border-color: grey !important;
  color: grey !important;

  &:active, &:focus {
    background: white !important;
    color: grey !important;
  }
}
</style>
